import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-all-owner-confirm',
  templateUrl: './all-owner-confirm.component.html',
  styleUrls: ['./all-owner-confirm.component.css']
})
export class AllOwnerConfirmComponent implements OnInit {

  constructor(public modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
